// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-381e78f4]{width:100%;margin:0 auto;position:relative;z-index:0}.text[data-v-381e78f4],.toolbar[data-v-381e78f4]{border:1px solid #ccc}.text[data-v-381e78f4]{min-height:500px}", ""]);
// Exports
module.exports = exports;
